;(function ( $, window, document, undefined ) {

  // Create the defaults once
  var pluginName = 'beCustomization',
    defaults = {
      repopulate: false,
      loadingContainer: '.o-form__loading',
      apiUrl: window.location.origin,
      submitOnChange: false,
      type: 'POST'
    };

  // The actual plugin constructor
  function Plugin( element, options ) {
    this.element = element;
    this.$element = $(element);

    this.options = $.extend( {}, defaults, options) ;

    this._defaults = defaults;
    this._name = pluginName;

    this.formData = {};

    this.init();
  }

  Plugin.prototype.init = function () {
    var Plugin = this;

    Plugin.$element.find(':input').on('input', function() {
      Plugin.$element.find('.js-beCustomization--save').prop('disabled', false);
    });

    Plugin.$element.find('input[name="color"]').on('change', function() {
      Plugin.$element.find('.js-beCustomization--demo-bar').css('background-color', $(this).val());
    });

    Plugin.$element.find('input[name="logo_image"]').on('input', function() {
      Plugin.$element.find('.js-beCustomization--demo-bar img').attr('src', $(this).val());
    });
  };


  // A really lightweight plugin wrapper around the constructor,
  // preventing against multiple instantiations
  $.fn[pluginName] = function ( options ) {
    return this.each(function () {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName,
          new Plugin( this, options ));
      }
    });
  }

})( jQuery, window, document );